import { jsx as n, jsxs as d, Fragment as i } from "react/jsx-runtime";
import { ah as p, j as g, d as b } from "../../vendor-Dd6qj6gJ.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as f } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as c } from "../BaseIcon/index.js";
import '../../assets/index3.css';const B = "_tag_onsr0_1", x = "_closeButton_onsr0_25", $ = "_truncate_onsr0_35", h = "_truncateLabel_onsr0_40", I = "_closeButtonIcon_onsr0_57", L = "_moon_onsr0_68", N = "_teal_onsr0_78", j = "_green_onsr0_88", v = "_cactus_onsr0_98", z = "_gold_onsr0_108", F = "_sienna_onsr0_118", R = "_red_onsr0_128", y = "_magenta_onsr0_138", O = "_purple_onsr0_148", P = "_blue_onsr0_158", o = {
  tag: B,
  closeButton: x,
  truncate: $,
  truncateLabel: h,
  closeButtonIcon: I,
  moon: L,
  teal: N,
  green: j,
  cactus: v,
  gold: z,
  sienna: F,
  red: R,
  magenta: y,
  purple: O,
  blue: P
};
function C({
  id: a,
  textValue: t,
  icon: s,
  color: e = "moon",
  removable: _ = !0,
  cssTruncate: r = !1,
  ...l
}) {
  return /* @__PURE__ */ n(
    p,
    {
      ...f(l),
      id: a,
      textValue: t,
      className: b(o.tag, o[e], r && o.truncate),
      children: ({ allowsRemoving: m, isDisabled: u }) => /* @__PURE__ */ d(i, { children: [
        s && /* @__PURE__ */ n(c, { icon: s, size: "xs", color: e, mr: 3 }),
        /* @__PURE__ */ n("span", { className: r ? o.truncateLabel : void 0, children: t }),
        m && _ && !u && /* @__PURE__ */ n(
          g,
          {
            excludeFromTabOrder: !0,
            slot: "remove",
            "aria-label": `Remove ${t}`,
            className: o.closeButton,
            children: /* @__PURE__ */ n(c, { icon: "close", size: "xs", color: e, className: o.closeButtonIcon })
          }
        )
      ] })
    }
  );
}
export {
  C as Tag
};
